import type { NotificationPage } from "../../api/gen/model";

/** The inbox's views: what asks a gesture, everything, what was set aside. */
export const inboxViews = ["to_do", "all", "archived"] as const;

export type InboxView = (typeof inboxViews)[number];

/** The view the address names, so a link keeps its target. */
export function validateViewSearch(search: Record<string, unknown>): { tab?: InboxView } {
  const tab = inboxViews.find((value) => value === search["tab"]);
  return tab === undefined ? {} : { tab };
}

/** « À faire » when something asks a gesture; « Tout » when nothing does but something is unread, so the bell's count
 * leads to what it counts. */
export function defaultView(page: Pick<NotificationPage, "to_do" | "unread">): InboxView {
  return page.to_do === 0 && page.unread > 0 ? "all" : "to_do";
}
